import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ROLES = ['admin', 'interviewer', 'candidate'];

const UserEditModal = ({ user, onSave, onCancel, isSaving = false }) => {
    const [name, setName] = useState('');
    const [idNumber, setIdNumber] = useState('');
    const [role, setRole] = useState('candidate');

    useEffect(() => {
        if (user) {
            setName(user.name || '');
            setIdNumber(user.id_number || '');
            setRole(user.role || 'candidate');
        }
    }, [user]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) return;
        onSave({ id: user.id, name: name.trim(), id_number: idNumber.trim(), role, email: user.email });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-campus-surface rounded-2xl shadow-soft max-w-md w-full mx-4">
                <div className="p-6 border-b border-campus-border">
                    <h2 className="text-xl font-heading font-bold text-campus-text-primary">Edit User</h2>
                    <p className="text-xs text-campus-text-body mt-1">{user.email}</p>
                </div>
                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    {/* Employee ID */}
                    <div>
                        <label htmlFor="edit-employee-id" className="block text-sm font-medium text-campus-text-primary mb-1">
                            Employee ID
                        </label>
                        <input
                            id="edit-employee-id"
                            type="text"
                            value={idNumber}
                            onChange={(e) => setIdNumber(e.target.value)}
                            placeholder="e.g. EMP001"
                            className="w-full border border-campus-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                        />
                    </div>

                    {/* Name */}
                    <div>
                        <label htmlFor="edit-name" className="block text-sm font-medium text-campus-text-primary mb-1">
                            Name <span className="text-campus-error">*</span>
                        </label>
                        <input
                            id="edit-name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Full name"
                            required
                            className="w-full border border-campus-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                        />
                    </div>

                    {/* Role */}
                    <div>
                        <label htmlFor="edit-role" className="block text-sm font-medium text-campus-text-primary mb-1">
                            Role <span className="text-campus-error">*</span>
                        </label>
                        <select
                            id="edit-role"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="w-full border border-campus-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition bg-campus-surface"
                        >
                            {ROLES.map((r) => (
                                <option key={r} value={r}>
                                    {r.charAt(0).toUpperCase() + r.slice(1)}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex justify-end gap-3 pt-2">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="px-5 py-2 border border-campus-border rounded-lg text-campus-text-body hover:bg-campus-bg font-medium transition text-sm"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isSaving || !name.trim()}
                            className={`px-5 py-2 rounded-lg text-white font-medium text-sm transition ${isSaving || !name.trim()
                                ? 'bg-campus-border cursor-not-allowed text-campus-text-body'
                                : 'bg-campus-primary hover:bg-campus-primary-dark'
                                }`}
                        >
                            {isSaving ? 'Saving…' : 'Save Changes'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

UserEditModal.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        email: PropTypes.string,
        id_number: PropTypes.string,
        role: PropTypes.string,
    }).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isSaving: PropTypes.bool,
};

export default UserEditModal;
